export const setAriaLabel = (product) => {
  if (product.isInStock) {
    return product.price.isOutletPrice || product.price.isMarkedDown
      ? `${product.name}. Original price ${product.price.previous.displayText}. Sale price ${product.price.current.text}.`
      : `${product.name}. ${product.price.current.text}`;
  }
  return `${product.name}. Currently out of stock.`;
};
